/* eslint-disable complexity */
import { columnType, DataType } from 'components/table/types';
import _ from 'lodash';
import { Stack, Switch, TextField, useTheme, Select, MenuItem } from '@mui/material';
import { CustomSwitch } from 'components/Inputs';
import { hasPermission } from 'components/AuthorizationComponent';
import { permissionEnums } from 'constants/permission.constants';

export const tableData = (data: any) => {
	return data?.map((item: any) => ({
		...item,
	}));
};

export const tableColumns: Record<string, string> = {
	name: 'custom',
	active: 'custom',
};

export const addDealerColumns = (type: string) => {
	if (type === 'altshulerDealers') {
		tableColumns.boUser = 'custom';
	} else {
		delete tableColumns.boUser;
	}
};

export const buildColumns = (
	t: any,
	handleEditButtonClick: any,
	saveItemChanges: any,
	cancelItemChanges: any,
	updateModifiedItem: any,
	updateBoUserItem: any,
	type: any,
	boUsers: any,
	takenBoUserIds: any
): columnType[] => {
	const theme = useTheme();
	const customerRelationsEditPermissions = hasPermission([permissionEnums.EDIT_CUSTOMER_RELATIONS]);
	const columns: columnType[] = [];
	addDealerColumns(type);
	_.keys(tableColumns).map((element: any, index: number) => {
		let customValueHandle = {};

		if (element === 'active') {
			customValueHandle = {
				customValueHandle: (value: any, row: Record<string, any>) => {
					return (
						<Stack direction={'row'} justifyContent={'space-between'} gap={10}>
							<CustomSwitch checked={value} theme={theme}>
								<Switch
									checked={value}
									disabled={!row?.editable}
									onChange={
										customerRelationsEditPermissions
											? () => updateModifiedItem(element, !value, row)
											: undefined
									}
								/>
							</CustomSwitch>
							{row?.editable ? (
								<Stack gap={5} direction={'row'}>
									{customerRelationsEditPermissions && !_.has(tableColumns, 'boUser') && (
										<>
											<img
												src={'icons/check.svg'}
												style={{
													cursor: row.name?.match(/^\s*$/g) ? 'auto' : 'pointer',
													opacity: row.name?.match(/^\s*$/g) ? 0.5 : 1,
												}}
												onClick={
													row.name?.match(/^\s*$/g) ? undefined : () => saveItemChanges(row)
												}
											/>
											<img
												src={'icons/cancel.svg'}
												style={{ cursor: 'pointer' }}
												onClick={() => cancelItemChanges()}
											/>
										</>
									)}
								</Stack>
							) : (
								<>
									{customerRelationsEditPermissions && !_.has(tableColumns, 'boUser') && (
										<img
											src={'icons/pencil.svg'}
											style={{ cursor: 'pointer' }}
											onClick={() => handleEditButtonClick(row.id)}
										/>
									)}
								</>
							)}
						</Stack>
					);
				},
			};
		}
		if (element === 'boUser') {
			customValueHandle = {
				customValueHandle: (value: any, row: Record<string, any>) => {
					return (
						<Stack direction="row" justifyContent="space-between" gap={10}>
							{row?.editable ? (
								<>
									<Select
										fullWidth
										sx={{ m: 1, minWidth: 250, borderRadius: '4px' }}
										size="small"
										value={row.boUserId ? row.boUserId : null}
										displayEmpty
										onChange={(event) => {
											updateBoUserItem(element, event.target.value, row);
										}}
										renderValue={(selected) => {
											const selectedUser = boUsers.find((user: any) => user.id === selected);
											return selectedUser
												? `${selectedUser.firstName} ${selectedUser.lastName}`
												: `${t(
														'page.customer_relations_management.table.column.noAssignedBoUser'
												  )}`;
										}}
									>
										<MenuItem value={''}>
											<em>
												{t('page.customer_relations_management.table.column.noAssignedBoUser')}
											</em>
										</MenuItem>

										{boUsers.map((user: any) => {
											return (
												<MenuItem
													key={user.id}
													value={user.id}
													disabled={
														takenBoUserIds.includes(user.id) && user.id !== row.boUserId
													}
												>
													{user.firstName} {user.lastName}
												</MenuItem>
											);
										})}
									</Select>

									{customerRelationsEditPermissions && (
										<Stack direction="row" gap={5}>
											<img
												src="icons/check.svg"
												style={{
													width: 25,
													cursor: row.name?.match(/^\s*$/g) ? 'auto' : 'pointer',
													opacity: row.name?.match(/^\s*$/g) ? 0.5 : 1,
												}}
												onClick={
													row.name?.match(/^\s*$/g) ? undefined : () => saveItemChanges(row)
												}
											/>
											<img
												src="icons/cancel.svg"
												style={{ width: 25, cursor: 'pointer' }}
												onClick={() => cancelItemChanges()}
											/>
										</Stack>
									)}
								</>
							) : (
								<Select
									fullWidth
									sx={{ m: 1, minWidth: 250, borderRadius: '4px' }}
									size="small"
									value={row.boUserId ? row.boUserId : ''}
									displayEmpty
									disabled
									renderValue={(selected) => {
										const selectedUser = boUsers.find((user: any) => user.id === selected);
										return selectedUser
											? `${selectedUser.firstName} ${selectedUser.lastName}`
											: `${t(
													'page.customer_relations_management.table.column.noAssignedBoUser'
											  )}`;
									}}
								>
									<MenuItem value={''}>
										<em>{t('page.customer_relations_management.table.column.noAssignedBoUser')}</em>
									</MenuItem>
									{boUsers.map((user: any) => (
										<MenuItem key={user.id} value={user.id}>
											{user.firstName} {user.lastName}
										</MenuItem>
									))}
								</Select>
							)}

							{!row?.editable && customerRelationsEditPermissions && (
								<img
									src="icons/pencil.svg"
									style={{ cursor: 'pointer' }}
									onClick={() => handleEditButtonClick(row.id)}
								/>
							)}
						</Stack>
					);
				},
			};
		}

		if (element === 'name') {
			customValueHandle = {
				customValueHandle: (value: any, row: Record<string, any>) => {
					return (
						<>
							{row?.editable ? (
								<TextField
									fullWidth
									sx={{
										'& .MuiInputBase-root': {
											minWidth: 300,
											maxHeight: '34px',
											border: value?.match(/^\s*$/g) ? '1px solid red' : 'auto',
										},
									}}
									value={value}
									onChange={
										customerRelationsEditPermissions
											? (event: any) => {
													updateModifiedItem(element, event?.target.value, row);
											  }
											: undefined
									}
								/>
							) : (
								value
							)}
						</>
					);
				},
			};
		}
		const props: columnType = {
			fieldId: 'id',
			name: element,
			title: t('page.customer_relations_management.table.column.' + element),
			type: _.get(tableColumns, element) as DataType,
			sortable: true,
			...customValueHandle,
		};
		columns.push(props);
	});
	return columns;
};
